module.exports = __webpack_public_path__ + "assets/9d1502b4a2e5d1d7a3f387fe98dfbd28.mp3";